import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function LandingPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Auto-redirect if user is already registered
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      navigate('/danmu');
    }
  }, [navigate]);

  return (
    <div className="container" style={{ textAlign: 'center', padding: '40px' }}>
      <h1>课堂弹幕系统</h1>
      <p style={{ marginBottom: '30px', fontSize: '18px', color: '#666' }}>
        选择您的身份进入系统
      </p>
      
      <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
        <button 
          className="btn" 
          style={{ 
            padding: '20px 40px', 
            fontSize: '18px',
            background: '#4CAF50'
          }}
          onClick={() => navigate('/danmu')}
        >
          学生 - 查看弹幕
        </button>
        
        <button 
          className="btn" 
          style={{ 
            padding: '20px 40px', 
            fontSize: '18px',
            background: '#2196F3'
          }}
          onClick={() => navigate('/teacher')}
        >
          教师 - 管理课堂
        </button>
        
        <button 
          className="btn" 
          style={{ 
            padding: '20px 40px', 
            fontSize: '18px',
            background: '#FF9800'
          }}
          onClick={() => navigate('/admin')}
        >
          管理员 - 后台管理
        </button>
      </div>
      
      <div style={{ marginTop: '40px', fontSize: '14px', color: '#999' }}>
        <p>提示：如果您之前已经注册过，将自动跳转到弹幕页面</p>
      </div>
    </div>
  );
}

export default LandingPage;